const generateToken = (size: number) => {
  const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const array: string[] = [];
  for (let index = 0; index < size; index += 1) {
    array.push(chars.charAt(Math.floor(Math.random() * chars.length)));
  }
  return array.join('');
};

export default generateToken;
